import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Colors from "../../theme/colors.json";
import { MenuItem, Select } from "@mui/material";
import { INITIAL_THEME } from "../../theme";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { getCommissionCounts } from "../../services/ChartService";
import { pushNotification } from "../../redux/actions";
import CONSTANTS, { Chart_Errors } from "../../constants/constants";
import { useDispatch, useSelector } from "react-redux";
import NoData from "./NoData";

const useStyles = makeStyles((theme) => ({
  responsiveContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  filterContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "3%",
  },
  filtersSection: {
    display: "flex",
    gap: "3%",
    // justifyContent: "space-around",
    // width: "50%",
  },
  selectStyles: {
    color: theme.palette.primary.main,
    fontSize: theme.fontSizes.SMALL,
    height: "1.6rem",
    minWidth: "6rem",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "& .MuiSvgIcon-root": {
      fill: `${theme.palette.primary.main} !important`,
    },
  },

  graphHeading: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 600,
    // width: "10%",
    // color: theme.palette.secondary.main,
  },

  selectRoot: {
    border: "unset",
    borderColor: theme.palette.primary.main,
  },

  circularProgress: {
    width: "38%",
  },
  commissionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
  },
  commissionText: {
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 500,
    color: "#7A7A7A",
  },
  commissionValue: {
    fontSize: theme.fontSizes.SMALL,
    fontWeight: 800,
  },
  circleTextContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  outstandingCirclePercentage: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 600,
    color: Colors.GRAPH_QUATERNANRY_COLOR,
  },
  receivedCirclePercentage: {
    fontSize: theme.fontSizes.LARGE,
    fontWeight: 600,
    color: Colors.GRAPH_TERITARY_COLOR,
  },
}));

const data = [{ name: "Group A", value: 100 }];
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const OutstandingCircleStyle = {
  // Rotation of path and trail, in number of turns (0-1)
  rotation: 0.25,

  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
  strokeLinecap: "butt",

  // Text size
  textSize: "16px",

  // How long animation takes to go from one percentage to another, in seconds
  pathTransitionDuration: 0.5,

  // Can specify path transition in more detail, or remove it entirely
  // pathTransition: 'none',

  // Colors
  pathColor: Colors.GRAPH_QUATERNANRY_COLOR,
  textColor: Colors.GRAPH_QUATERNANRY_COLOR,
  trailColor: "#d6d6d6",
  backgroundColor: "#3e98c7",
};

const ReceivedCircleStyle = {
  // Rotation of path and trail, in number of turns (0-1)
  rotation: 0.25,

  // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
  strokeLinecap: "butt",

  // Text size
  textSize: "16px",

  // How long animation takes to go from one percentage to another, in seconds
  pathTransitionDuration: 0.5,

  // Can specify path transition in more detail, or remove it entirely
  // pathTransition: 'none',

  // Colors
  pathColor: Colors.GRAPH_TERITARY_COLOR,
  textColor: Colors.GRAPH_TERITARY_COLOR,
  trailColor: "#d6d6d6",
  backgroundColor: "#3e98c7",
};

const CommissionStatusChart = ({ years, months }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedYear, setSelectedYear] = useState(
    years[0]?.value || new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [chartData, setChartData] = useState<any>({});

  const [isLoading, setIsLoading] = useState(false);

  const handleGetCommissionCounts = async () => {
    setIsLoading(true);
    const response = await getCommissionCounts(selectedMonth, selectedYear);
    if (response?.success) {
      setChartData(response?.data);
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.SUCCESS,
      //   })
      // );
    } else {
      setChartData({});
      setIsLoading(false);
      // dispatch(
      //   pushNotification({
      //     isOpen: true,
      //     message: response.message,
      //     type: CONSTANTS.ERROR,
      //   })
      // );
    }
  };

  useEffect(() => {
    handleGetCommissionCounts();
  }, [selectedYear, selectedMonth]);

  return (
    <>
      <div className={classes.filterContainer}>
        <div className={classes.graphHeading}>Commission Status</div>
        <div className={classes.filtersSection}>
          <Select
            size="small"
            className={classes.selectStyles}
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            {years?.map((item, index) => {
              return (
                <MenuItem key={index} value={item?.value}>
                  {item?.title}
                </MenuItem>
              );
            })}
          </Select>
          <Select
            size="small"
            className={classes.selectStyles}
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(e.target.value)}
          >
            {months?.map((item, index) => {
              return (
                <MenuItem key={index} value={item?.value}>
                  {item?.title}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      </div>
      {Object.keys(chartData)?.length > 0 && !isLoading && (
        <>
          <div className={classes.responsiveContainer}>
            <div className={classes.circularProgress}>
              <CircularProgressbarWithChildren
                value={chartData?.outStandingSum}
                maxValue={chartData?.totalCommissionSum}
                styles={buildStyles(OutstandingCircleStyle)}
              >
                <div className={classes.circleTextContainer}>
                  <div className={classes.outstandingCirclePercentage}>
                    {chartData?.outStandingSumPercentage?.toFixed(2)}%
                  </div>
                  <div className={classes.commissionContainer}>
                    <div className={classes.commissionText}>Outstanding</div>
                    <div className={classes.commissionValue}>
                      {chartData?.outStandingSum}
                    </div>
                  </div>
                </div>
              </CircularProgressbarWithChildren>
            </div>
            <div className={classes.circularProgress}>
              <CircularProgressbarWithChildren
                value={chartData?.receivedSum}
                maxValue={chartData?.totalCommissionSum}
                styles={buildStyles(ReceivedCircleStyle)}
              >
                <div className={classes.circleTextContainer}>
                  <div className={classes.receivedCirclePercentage}>
                    {chartData?.receivedSumPercentage?.toFixed(2)}%
                  </div>
                  <div className={classes.commissionContainer}>
                    <div className={classes.commissionText}>Received</div>
                    <div className={classes.commissionValue}>
                      {chartData?.receivedSum}
                    </div>
                  </div>
                </div>
              </CircularProgressbarWithChildren>
            </div>
          </div>

          <div className={classes.commissionContainer}>
            <div className={classes.commissionText}>Total Commission</div>
            <div className={classes.commissionValue}>
              {chartData?.totalCommissionSum}
            </div>
          </div>
        </>
      )}

      {Object.keys(chartData)?.length === 0 && !isLoading && (
        <NoData errorLabel={Chart_Errors.commission_error} />
      )}
    </>
  );
};

export default CommissionStatusChart;
